import AppearanceStoreModule from '@webitel/ui-sdk/src/modules/Appearance/store/AppearanceStoreModule';

export default new AppearanceStoreModule().getModule();
